// extracted by mini-css-extract-plugin
export default {"container":"SocialLinks_container__-cPEm","link":"SocialLinks_link__cwKwb"};